import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { Analyzer } from 'types';

export const getAnalyzers = async (): Promise<Analyzer[]> => {
  const { data } = await axios.get('/api/analyzers');
  return data as Analyzer[];
};

type QueryFnType = typeof getAnalyzers;

type UseAnalyzersOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAnalyzers = ({ config }: UseAnalyzersOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['analyzers'],
    queryFn: () => getAnalyzers(),
  });
};
